"use client"

import * as React from "react"

import { useQuestionDimensions } from "@/hooks/use-category-dimensions"
import { useCourseAssignments } from "@/hooks/use-course-assignments"
import { useExamCategories } from "@/hooks/use-exam-categories"
import {
  QuestionCategorization,
  type CategorizableQuestion,
} from "@/lib/exam-categories"

/** The one way a surface gets a question's categorization: live tree, live standard. */
export function useQuestionCategorization(
  question: CategorizableQuestion,
  folders?: readonly { id: string; name: string; parentId: string | null }[],
): QuestionCategorization {
  const { categories } = useExamCategories()
  const dimension = useQuestionDimensions()[0]
  const { assignments } = useCourseAssignments()
  return React.useMemo(
    () => QuestionCategorization.of(question, { categories, dimension, folders, assignments }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [assignments, categories, dimension, folders, question.topic, question.categoryIds, question.categoryUnassigned, question.folderId, question.folderIds],
  )
}
